import { render, staticRenderFns } from "./SubNavSidebar.vue?vue&type=template&id=af8e033e&"
import script from "./SubNavSidebar.vue?vue&type=script&lang=js&"
export * from "./SubNavSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports